import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_ConvexHull_JarvisMarch = () => (
  <DAAModuleSubtopic
    title="Convex Hull: Jarvis March (Gift Wrapping Algorithm)"
    videos={[
      "https://www.youtube.com/embed/nBvCZi34F_o",
      "https://www.youtube.com/embed/Vu84lmMzP2o",
      "https://www.youtube.com/embed/B2AJoQSZf4M"
    ]}
    takeaways={[
      { text: "Time Complexity: O(nh), where n → number of points and h → number of points on the convex hull." },
      { text: "Step 1: Start from the leftmost point (with the smallest x-coordinate)." },
      { text: "Step 2: At each step, choose the point that is the most counter-clockwise relative to the current point." },
      { text: "Step 3: Repeat until the algorithm returns to the starting point, forming a closed convex polygon." },
      { text: "Step 4: Orientation is determined using the cross product: AB × AC > 0 means C is to the left of AB." },
      { text: "Advantages: Efficient for smaller datasets or when convex hull size (h) is small compared to total points (n)." },
      { text: "Disadvantages: Slower than Graham’s Scan for large datasets, sensitive to collinear points." },
      { text: "Applications: Used in computational geometry, robotics, pattern recognition, and collision detection." },
      { image: "/JarvisMarch.png",}
    ]}
    questions={[
      {
        text: "Write the pseudocode for the Jarvis-March algorithm and trace it for the points provided in the diagram below.",
        image: "/Jarvis q1.png"
      },
      {
        text: "Relate Graham's Scan and Jarvis March Algorithm steps and explain how to choose the best practices for computing Convex Hulls. Provide an illustrative example."
      }
    ]}
    exampleVideos={[]}
  />
);

export default DAA_ConvexHull_JarvisMarch ;
